export enum EPaymentReversalStatus {
  Active = 'Active',
  Cancel = 'Cancel',
}
